import axios from "axios";
import { apiConfiguration } from "plumbing/api";

export const fetchCreateCheckoutSessionLink = (priceId: string) => {
  const url = `${apiConfiguration.apiUrl}/subscriptions/create-checkout-session?priceId=${priceId}`;
  return axios.get<string>(url);
};
